module.exports = __webpack_public_path__ + "static/media/Whatsapp_Guide_iOS_Chin.c4814af1.pdf";